import { SettingsContainerTitleProps } from './SettingsContainer';

import styles from './SimpleTitle.module.scss';

export interface SimpleTitleProps extends SettingsContainerTitleProps {
	text: string;
}
export const SimpleTitle = (props: SimpleTitleProps) => {
	if (props.isExpanded) {
		return (
			<a className={styles.expanded} onClick={() => props.setIsExpanded(false)}>
				<i className="fa fa-angle-left"></i>
				<span>{ props.text }</span>
			</a>
		);
	}
	else {
		return (
			<a className={styles.collapsed} onClick={() => props.setIsExpanded(true)}>
				<i className="fa fa-angle-right"></i>
				<span>{props.text}</span>
			</a>
		);
	}
}